import React from "react";
import { createRoot } from "react-dom/client";
import { HeroUIProvider } from "@heroui/react";
import { App } from "./App.jsx";
import "./styles.css";

document.documentElement.classList.add("dark", "kaputDark");
const savedTheme = localStorage.getItem("kaput_theme") || "theme1";
document.documentElement.setAttribute("data-theme", savedTheme);

class AppErrorBoundary extends React.Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, background: "#1f1242", color: "#fff", minHeight: "100vh", fontFamily: "sans-serif" }}>
          <h1>發生錯誤</h1>
          <pre style={{ overflow: "auto", fontSize: 12 }}>{this.state.error?.message || "Unknown"}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <HeroUIProvider>
        <App />
      </HeroUIProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
